import { Input } from "antd";
import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconEye, IconEyeInvisible } from "../../../assets/icon";

const InputPassWord = ({
  setPassWord,
  password,
  placeholder = "Mật khẩu",
  typeInput,
  style,
  prefix,
}) => {
  const { t } = useTranslation();
  const [hide, setHide] = useState(true);
  return (
    <div className={typeInput} style={style}>
      <Input
        autoComplete="new-password"
        type={hide ? "password" : "text"}
        prefix={prefix}
        value={password}
        onChange={(e) => setPassWord(e.target.value)}
        placeholder={t(placeholder)}
        suffix={
          <span onClick={(e) => setHide(!hide)}>
            {hide ? <IconEyeInvisible /> : <IconEye />}
          </span>
        }
      />
    </div>
  );
};

export default InputPassWord;
